import { TextFieldProps } from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import { FieldValues } from 'react-hook-form';

import { TControllerProps, TSelectOption } from 'common/types';
import { TextField } from 'common/forms/Field/TextField';

interface IProps extends Omit<TextFieldProps, 'options' | 'name'> {
    name: string;
    options: TSelectOption[];
    displayEmpty?: boolean;
}

export const SelectField = <TFieldValues extends FieldValues>({
    name,
    options,
    displayEmpty,
    ...other
}: IProps & TControllerProps<TFieldValues>) => (
    <TextField
        fullWidth
        select
        margin="normal"
        name={name}
        slotProps={{
            inputLabel: { shrink: displayEmpty },
            select: { displayEmpty },
        }}
        variant="outlined"
        {...other}
    >
        {options.map((option, index) =>
            option.divider ? (
                <Divider
                    component="li"
                    key={`divider-${index}`}
                    sx={{ my: 1.25 }}
                />
            ) : (
                <MenuItem
                    disabled={option.disabled}
                    key={option.value ?? `option-${index}`}
                    style={{ whiteSpace: 'normal' }}
                    sx={{ py: 0.5 }}
                    value={option.value}
                >
                    <Typography variant="inherit">{option.label}</Typography>
                </MenuItem>
            )
        )}
    </TextField>
);
